import React, { useState } from "react";
import { Button, Box } from '@mui/material';
import F1 from './bsoeF1';
import F2 from './bsoeF2';
import F3 from './bsoeF3';
import Fb from './bsoeFb';
import { BrowserView, MobileView } from "react-device-detect";

function BSOE_FloorButton({ floorNumber, onClick, disabled }) {
    return (
        //<BrowserView>
        <Button
            variant="contained"
            color="primary"
            className="floor-button"
            disabled={disabled}
            onClick={() => onClick(floorNumber)}
            style={{ margin: '8px' }}
        >
            {floorNumber === 'B' ? 'Floor B' : `Floor ${floorNumber}`}
        </Button>

    );
}

function BSOE_Buttons() {
    const [selectedFloor, setSelectedFloor] = useState(null);

    const handleFloorClick = (floorNumber) => {
        setSelectedFloor(floorNumber);
    };

    return (
        <>
            <Box marginLeft={77} marginTop={-24}>
                <BSOE_FloorButton floorNumber={'B'} onClick={handleFloorClick} disabled={selectedFloor === 'B'} />
                <BSOE_FloorButton floorNumber={1} onClick={handleFloorClick} disabled={selectedFloor === 1} />
                <BSOE_FloorButton floorNumber={2} onClick={handleFloorClick} disabled={selectedFloor === 2} />
                <BSOE_FloorButton floorNumber={3} onClick={handleFloorClick} disabled={selectedFloor === 3} />
            </Box>

            {selectedFloor === 'B' && <Fb />}
            {selectedFloor === 1 && <F1 />}
            {selectedFloor === 2 && <F2 />}
            {selectedFloor === 3 && <F3 />}

        </>
    );
}

export default BSOE_Buttons;
